<template>
  <div>
    <div
      class="status-label"
      :id="triggerName"
      @mouseover="toggle = true"
      @mouseleave="toggle = false"
      @focus="toggle = true"
      @blur="toggle = false"
    >
      <mds-inline-message
        size="small"
        :tinted="tinted"
        :variation="status.variation"
      >
        {{ translate(status.text) }}
      </mds-inline-message>
    </div>
    <mds-tooltip
      v-if="status.variation === 'error'"
      v-model="toggle"
      class="status-label__tooltip"
      size="small"
      :triggered-by="triggerName"
      :position="['bottom-right']"
    >
      {{ translate('schedule.failed.message') }}
    </mds-tooltip>
  </div>
</template>

<script>
import MdsInlineMessage from '@mds/inline-message'
import MdsTooltip from '@mds/tooltip'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/scheduleStatus/config/i18n'

export default {
  name: 'StatusLabel',
  components: {
    MdsInlineMessage,
    MdsTooltip,
  },
  props: {
    status: {
      type: Object,
      default: () => ({}),
    },
    itemId: {
      type: [Number, String],
    },
    tinted: Boolean,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      toggle: false,
    }
  },
  computed: {
    triggerName() {
      return `triggerName-${this.itemId}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.status-label {
  width: fit-content;
}
</style>
